import { SIGN_IN_REQUEST, SIGN_IN_SUCCESS, SIGN_IN_FAILURE } from './actionTypes';

const initialState = {
  loading: false,
  error: '',
};

const signIn = (state = initialState, { type, error }) => {
  switch (type) {
    case SIGN_IN_REQUEST:
      return { ...state, loading: true };
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SIGN_IN_FAILURE:
      return { ...state, loading: false, error };
    default:
      return state;
  }
};

export default signIn;
